import React, { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';
import { get, noop } from 'lodash-es';

export default function withSmartListHandlers(WrappedComponent, key) {
  function WithSmartListHandlers({ title = '', updateHOCState = noop, ...rest }) {
    const onClick = useCallback(
      event => {
        const items = get(event.target.closest(`.${key}-item`), 'title', null);

        if (items) {
          updateHOCState(items);
        }
      },
      [updateHOCState]
    );

    return (
      <Fragment>
        {!!title && <h4 className="medium text-center">{title}</h4>}
        <WrappedComponent {...rest} onClick={onClick} />
      </Fragment>
    );
  }

  const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  WithSmartListHandlers.displayName = `withSmartListHandlers(${wrappedComponentName})`;

  WithSmartListHandlers.propTypes = {
    /**
     * listItem: PropTypes.shape({
     *   name: PropTypes.string, // ex: "Champagne Frost Pearl"
     *   properties: PropTypes.shape({
     *     rgb: PropTypes.string, // ex: "200,167,124"
     *   })
     *   count: PropTypes.number, // ex: 567
     * });
     *
     * or
     *
     * listItem: PropTypes.shape({
     *   name: PropTypes.string, // ex: "USB Inputs"
     *   value: PropTypes.string, // ex: "USB Inputs"
     *   count: PropTypes.number, // ex: 2438
     * });
     */
    listItems: PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.shape({
          name: PropTypes.string,
          count: PropTypes.number,
          properties: PropTypes.shape({
            rgb: PropTypes.string,
          }),
          price: PropTypes.shape({
            baseMSRP: PropTypes.number,
          }),
        }),
        PropTypes.shape({
          name: PropTypes.string,
          value: PropTypes.string,
          count: PropTypes.number,
        }),
      ])
    ).isRequired,
    updateHOCState: PropTypes.func,
    title: PropTypes.string,
  };

  return WithSmartListHandlers;
}
